import { Button, IconButton, Theme, useMediaQuery } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import ProcedureSalesFormDialog from './procedure-sales-form-dialog';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import { AddProcedureStockAllowanceType, ProcedureType } from '../entity';
import { ImperativeFormDialogRefType } from '@shared/components/UserFormDialog';
import { useRef } from 'react';
import AppTheme from '@libs/mui/AppTheme';
import ProcedureFormDialog from './procedure-consumption-form-dialog';

type ProcedureCardActionsProps = {
  cardType: ProcedureType;
  stockAllowances: AddProcedureStockAllowanceType;
  procedureId?: string;
  disabled?: boolean;
  description?: string;
  onRepeat: () => void;
  isLoading: boolean;
};

const ProcedureCardActions = ({
  cardType,
  description,
  stockAllowances,
  procedureId,
  disabled,
  onRepeat,
  isLoading,
}: ProcedureCardActionsProps) => {
  const consumptionDialogRef = useRef<ImperativeFormDialogRefType | null>(null);
  const salesDialogRef = useRef<ImperativeFormDialogRefType | null>(null);
  const isMedium = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));
  const borderRadiusSx = { xs: '0 0 10px 10px', sm: '0 10px 10px 0' };
  const borderSx = {
    borderLeft: { xs: 'none', sm: `1px dotted ${AppTheme.palette.secondary.main}` },
    borderTop: { xs: `1px dotted ${AppTheme.palette.secondary.main}`, sm: 'none' },
  };

  if (cardType === 'PREVIOUS_COPY') {
    return (
      <Button
        variant="contained"
        color="success"
        endIcon={<EventRepeatIcon />}
        onClick={onRepeat}
        disabled={isLoading}
        sx={{
          alignSelf: 'stretch',
          padding: isMedium ? '30px' : '12px',
          borderRadius: borderRadiusSx,
          ...borderSx,
        }}
      >
        <FormattedMessage id="procedureCard.repeat" defaultMessage="Opakovat" />
      </Button>
    );
  }

  const bgColor = cardType === 'SALE' ? 'info.main' : 'secondary.light';
  const activeRef = cardType === 'SALE' ? salesDialogRef : consumptionDialogRef;

  return (
    <>
      <IconButton
        onClick={() => activeRef.current?.open()}
        disabled={disabled}
        sx={{
          bgcolor: bgColor,
          alignSelf: 'stretch',

          borderRadius: borderRadiusSx,
          ...borderSx,
          color: 'white',
        }}
      >
        <EditOutlinedIcon sx={{ color: 'white' }} />
      </IconButton>
      {cardType === 'CONSUMPTION' && (
        <ProcedureFormDialog
          dialogRef={consumptionDialogRef}
          defaultValues={{ stockAllowances, description: description ?? '' }}
          procedureId={procedureId}
          hasNoProcedures={false}
          isVisitClosed={!!disabled}
          procedures={[]}
        />
      )}
      {cardType === 'SALE' && (
        <ProcedureSalesFormDialog
          dialogRef={salesDialogRef}
          defaultValues={{ stockAllowances }}
          procedureId={procedureId}
          isVisitClosed={!!disabled}
          procedures={[]}
        />
      )}
    </>
  );
};

export default ProcedureCardActions;
